import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { produce } from 'immer';
import type { GroupChannel } from '@sendbird/chat/groupChannel';

interface CurrentChannelState {
  currentChannel?: GroupChannel;
  setCurrentChannel: (channel: GroupChannel) => void;
  clearCurrentChannel: () => void;
}

const useCurrentChannel = create<CurrentChannelState>()(
  devtools(
    persist(
      (set) => ({
        currentChannel: undefined,
        setCurrentChannel(channel) {
          set(
            produce((draft: CurrentChannelState) => {
              draft.currentChannel = channel;
            }),
          );
        },
        clearCurrentChannel() {
          set(
            produce((draft: CurrentChannelState) => {
              draft.currentChannel = undefined;
            }),
          );
        },
      }),
      { name: 'CURRENT_CHANNEL_KEY' },
    ),
  ),
);

export default useCurrentChannel;
